module.exports = __webpack_public_path__ + "img/a300x300.1be5f198.jpg";